module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), (!_vm.origins.length) ? _c('div', {
    staticClass: "empty-state"
  }, [_vm._v("No sales data yet")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.origins), function(o) {
    return _c('div', {
      key: o.name,
      staticClass: "origin-item"
    }, [_c('span', {
      staticClass: "origin-code"
    }, [_vm._v(_vm._s(o.code))]), _vm._v(" "), _c('div', {
      staticClass: "origin-info"
    }, [_c('div', {
      staticClass: "origin-name"
    }, [_vm._v(_vm._s(o.name))]), _vm._v(" "), _c('div', {
      staticClass: "origin-track"
    }, [_c('div', {
      staticClass: "origin-fill",
      style: ({
        width: o.pct + '%'
      })
    })])]), _vm._v(" "), _c('div', {
      staticClass: "origin-pct"
    }, [_vm._v(_vm._s(o.pct) + "%")])])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-head"
  }, [_c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Guest Origin")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-49c02906", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49c02906"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/guestOrigin.vue
// module id = 3012
// module chunks = 0